import { DefaultTheme } from 'styled-components';

// Keep in sync with ./theme.less and DefaultTheme interface (src/types/StyledComponents.d.ts)
const theme: DefaultTheme = {
  font: {
    primary: 'Circular, Helvetica, Verdana, sans-serif', // Also set on the body in ./theme.less
    heading: 'Circular, Helvetica, Verdana, sans-serif',
    icon: 'Nerva Icon Pack',
  },
  fontSize: {
    xxxs: '10px',
    xxs: '14px',
    xs: '16px',
    sm: '18px',
    md: '24px',
    xmd: '33px',
    lg: '36px',
    xl: '48px',
    xxl: '72px',
    xxxl: '84px',
  },
  fontWeight: {
    light: 300,
    regular: 400,
    medium: 500,
    bold: 700,
  },
  spacing: {
    _2px: '2px',
    _4px: '4px',
    _6px: '6px',
    _8px: '8px',
    _10px: '10px',
    _12px: '12px',
    _14px: '14px',
    _16px: '16px',
    _18px: '18px',
    _20px: '20px',
    _22px: '22px',
    _24px: '24px',
    _26px: '26px',
    _28px: '28px',
    _30px: '30px',
    _32px: '32px',
    _34px: '34px',
    _36px: '36px',
    _38px: '38px',
    _40px: '40px',
    _42px: '42px',
    _44px: '44px',
    _46px: '46px',
    _48px: '48px',
    _50px: '50px',
    _60px: '60px',
    _66px: '66px',
    _80px: '80px',
  },
  shadow: {
    drop: {
      dark: 'box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.4);',
      gray: 'box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.08);',
      lightGray: 'box-shadow: 0px 4px 4px rgba(229, 229, 229, 0.35);',
    },
    inner: {
      gray: 'box-shadow: inset 0px 4px 3px rgba(0, 0, 0, 0.04);',
      green: 'box-shadow: inset 0px 4px 4px rgba(166, 222, 171, 0.1);',
    },
  },
  device: {
    mobile: '(max-width: 425px)',
    tablet: '(max-width: 600px)',
  },
} as const;

export default theme;
